export const variants = [
  // {amount: "10", price: "Zdarma", desc: "k založenému obchodnímu účtu"},
  { amount: '500', price: '990 Kč' },
  { amount: '2 000', price: '2 380 Kč' },
  { amount: '5 000', price: '3 690 Kč' },
];
